import { prop } from 'ramda';

import { DocumentType } from '../../../types/document';
import articleValidator from './article';
import defaultValidator from './default';

const validators = {
  [DocumentType.ARTICLE]: articleValidator,
};

export const validateByType = (document) =>
  (validators[prop('type', document)] || defaultValidator)(document);
